import { clsx } from "@trydig/ui";
import type React from "react";
import { forwardRef } from "react";
import { SortIcon } from "~/components/icons/SortIcon";
import styles from "./styles.module.css";

export const NativeSelect = forwardRef<HTMLSelectElement, React.ComponentProps<"select">>(
	({ className, ...props }, ref) => {
		return (
			<div className={styles.wrapper}>
				<select className={clsx(className, styles.trigger)} {...props} ref={ref} />
				<label htmlFor="">
					<SortIcon className={styles.indicator} />
				</label>
			</div>
		);
	},
);
